import request from "@/utils/request";

/**
 * 查询产品需求列表
 * @param {Object} params
 * @param {string} params.productName - 产品名称
 * @param {string} params.productTypeId - 产品分类
 */
export function getDemandList(params) {
  return request({
    url: "/app/demand/list",
    method: "get",
    params,
  });
}

/**
 * 获取产品需求详细信息
 * @param {string|number} demandId - 需求ID
 */
export function getDemandDetail(demandId) {
  return request({
    url: `/app/demand/${demandId}`,
    method: "get",
  });
}

/**
 * 发布产品需求
 * @param {Object} data
 * @param {string} data.productName - 产品名称
 * @param {string} data.productType - 产品分类
 * @param {string} data.relationPhone - 联系方式
 * @param {string} data.verifyEndTime - 验样截止时间
 * @param {string} data.qualityDemand - 质量要求
 * @param {string} data.productRemark - 备注
 * @param {string} data.productPicture - 产品图片（多个URL逗号分隔）
 * @param {string} data.invoicePicture - 发票图片URL（多个URL逗号分隔）
 * @param {string} data.invoiceTitle - 发票抬头（多个URL逗号分隔）
 * @param {string} data.taxNumber - 税号（多个URL逗号分隔）
 * @param {string} data.serviceType - 发票服务类型（多个URL逗号分隔）
 * @param {string} data.serviceName - 发票服务名称（多个URL逗号分隔）
 * @param {string} data.demandStatus - 需求状态(draft=草稿,release=发布/验样阶段,wait_order=待发起订单,bidding=竞价阶段,repurchase_bidding=复购竞价,completed=已完成,close=关闭)
 */
export function publishDemand(data) {
  return request({
    url: "/app/demand",
    method: "post",
    data,
  });
}

/**
 * 发票识别（OCR）
 * @param {Object} data
 * @param {string} data.imageUrl - 发票图片URL
 */
export function invoiceOcr(data) {
  return request({
    url: "/aliOcr/invoice",
    method: "post",
    data,
  });
}

/**
 * 查询我的需求列表
 * @param {Object} params
 * @param {string} params.demandStatus - 需求状态(draft=草稿,release=发布/验样阶段,wait_order=待发起订单,bidding=竞价阶段,repurchase_bidding=复购竞价,completed=已完成,close=关闭)
 * @param {number} params.pageNum - 当前记录起始索引
 * @param {number} params.pageSize - 每页显示记录数
 */
export function getMyDemandList(params) {
  return request({
    url: "/app/demand/myDemand",
    method: "get",
    params,
  });
}

/**
 * 供应方信息查看
 * @param {Object} params
 * @param {string} params.status - 状态(all=全部,apply=验样中,wait_bidding=待竞价,bidding=竞价中,pass=已完成,repurchase_bidding=复购竞价,verify_fail=验样失败,bidding_fail=竞价失败,close=已终止)
 * @param {number} params.pageNum - 当前记录起始索引
 * @param {number} params.pageSize - 每页显示记录数
 */
export function getSupplierRecordInfo(params) {
  return request({
    url: "/app/demand/supplierRecordInfo",
    method: "get",
    params,
  });
}

/**
 * 新增申请验样
 * @param {Object} data
 * @param {string} data.demandId - 需求ID
 * @param {string} data.enterpriseName - 企业名称
 * @param {string} data.relationName - 联系人
 * @param {string} data.relationPhone - 联系方式
 * @param {string} data.postName - 职务
 * @param {string} data.wxNumber - 微信号
 * @param {string} data.mail - E-mail
 * @param {string} data.address - 地址
 * @param {string} data.applyRemark - 申请备注
 */
export function applyVerify(data) {
  return request({
    url: "/app/applyVerify",
    method: "post",
    data,
  });
}

/**
 * 查询需求申请验样列表
 * @param {string|number} demandId - 需求ID
 */
export function getApplyVerifyList(demandId) {
  return request({
    url: "/app/applyVerify/queryByDemand",
    method: "get",
    params: {
      demandId: demandId,
    },
  });
}

/**
 * 获取申请验样详细信息
 * @param {string|number} applyVerifyId - 申请验样ID
 */
export function getApplyVerifyDetail(applyVerifyId) {
  return request({
    url: `/app/applyVerify/${applyVerifyId}`,
    method: "get",
  });
}

/**
 * 结束验样
 * @param {string} demandId - 需求ID
 */
export function finishVerifyEnd(demandId) {
  return request({
    url: `/app/demand/finishVerify/${demandId}`,
    method: "get",
  });
}

/**
 * 采购方审核验样（通过/不通过）
 * @param {Object} data
 * @param {string|number} data.applyVerifyId - 申请验样ID
 * @param {string} data.applyStatus - 状态(pass=通过, not_pass=未通过)
 * @param {string} data.auditExplain - 审核说明
 */
export function auditApplyVerify(data) {
  return request({
    url: "/app/applyVerify/audit",
    method: "post",
    data,
  });
}

/**
 * 取消需求
 * @param {Object} data
 * @param {string|number} data.demandId - 需求ID
 * @param {string} data.closeExplain - 需求关闭说明
 */
export function closeDemand(data) {
  return request({
    url: "/app/demand/close",
    method: "post",
    data,
  });
}

/**
 * 终止申请验样
 * @param {Object} data
 * @param {string|number} data.applyVerifyId - 申请验样ID
 * @param {string} data.closeExplain - 终止说明
 */
export function closeApplyVerify(data) {
  return request({
    url: "/app/applyVerify/close",
    method: "post",
    data,
  });
}

/**
 * 获取需求订单详情
 * @param {string|number} demandId - 需求ID
 */
export function getDemandOrderDetail(demandId) {
  return request({
    url: `/app/demandOrder/${demandId}`,
    method: "get",
  });
}

/**
 * 发起订单
 * @param {Object} data
 * @param {string|number} data.demandId - 需求ID
 * @param {string} data.productName - 产品名称
 * @param {string} data.productType - 产品分类
 * @param {number} data.number - 数量
 * @param {string} data.relationName - 联系人
 * @param {string} data.relationPhone - 联系电话
 * @param {string} data.deliveryTime - 交货时间
 * @param {string} data.payMethod - 付款方式
 * @param {string} data.productQuality - 产品质量
 * @param {string} data.productPicture - 产品图片（多个URL逗号分隔）
 * @param {string} data.orderInfo - 订单信息
 * @param {string} data.orderRemark - 订单备注
 */
export function createDemandOrder(data) {
  return request({
    url: "/app/demandOrder",
    method: "post",
    data,
  });
}

/**
 * 通过需求查询报价列表
 * @param {string|number} demandId - 需求ID
 */
export function getBiddingListByDemand(demandId) {
  return request({
    url: "/app/bidding/queryByDemand",
    method: "get",
    params: {
      demandId: demandId,
    },
  });
}

/**
 * 提交竞价
 * @param {Object} data
 * @param {string|number} data.demandId - 需求ID
 * @param {string|number} data.demandOrderId - 需求订单ID
 * @param {string} data.productName - 产品名称
 * @param {string} data.productType - 产品分类
 * @param {number} data.number - 数量
 * @param {string} data.relationName - 联系人
 * @param {string} data.relationPhone - 联系电话
 * @param {string} data.deliveryTime - 交货时间
 * @param {string} data.payMethod - 付款方式
 * @param {string} data.productQuality - 产品质量
 * @param {number} data.price - 单价
 * @param {string} data.totalAmount - 总价
 * @param {string} data.productPicture - 产品图片（多个URL逗号分隔）
 * @param {string} data.orderInfo - 订单信息
 * @param {string} data.biddingRemark - 竞价备注
 * @param {string} data.serialNumber - 后面加的 接口文档上没有
 */
export function submitBidding(data) {
  return request({
    url: "/app/bidding",
    method: "post",
    data,
  });
}

/**
 * 获取竞价详细信息
 * @param {string|number} biddingId - 竞价ID
 */
export function getBiddingDetail(biddingId) {
  return request({
    url: `/app/bidding/${biddingId}`,
    method: "get",
  });
}

/**
 * 采购方审核竞价（通过/未通过）
 * @param {Object} data
 * @param {string|number} data.biddingId - 竞价ID
 * @param {string} data.biddingStatus - 竞价状态(bidding=已竞价,pass=通过,not_pass=未通过,close=终止)
 * @param {string} data.auditExplain - 审核说明
 */
export function auditBidding(data) {
  return request({
    url: "/app/bidding/audit",
    method: "post",
    data,
  });
}

/**
 * 修改竞价
 * @param {Object} data
 * @param {string|number} data.biddingId - 竞价ID
 * @param {string} data.productName - 产品名称
 * @param {string} data.productType - 产品分类
 * @param {number} data.number - 数量
 * @param {string} data.relationName - 联系人
 * @param {string} data.relationPhone - 联系电话
 * @param {string} data.deliveryTime - 交货时间
 * @param {string} data.payMethod - 付款方式
 * @param {string} data.productQuality - 产品质量
 * @param {number} data.price - 单价
 * @param {string} data.totalAmount - 总价
 * @param {string} data.productPicture - 产品图片(多个)
 * @param {string} data.orderInfo - 订单信息
 * @param {string} data.biddingRemark - 竞价备注
 */
export function editBidding(data) {
  return request({
    url: "/app/bidding/edit",
    method: "post",
    data,
  });
}

/**
 * 关闭竞价
 * @param {Object} data
 * @param {string|number} data.biddingId - 竞价ID
 * @param {string} data.closeExplain - 终止说明
 */
export function closeBidding(data) {
  return request({
    url: "/app/bidding/close",
    method: "post",
    data,
  });
}

/**
 * 查询需求推荐供应商列表
 * @param {string|number} demandId - 需求ID
 */
export function getReferralsSupplierList(demandId) {
  return request({
    url: `/app/referralsSupplier/queryByDemand/${demandId}`,
    method: "get",
  });
}

/**
 * 查询需求汇总
 */
export function getDemandSummary() {
  return request({
    url: "/app/demand/demandSummary",
    method: "get",
  });
}

/**
 * 邀请推荐供应商
 * @param {Object} data
 * @param {Array} data.supplierIds - 邀请供应商ID列表
 * @param {string|number} data.demandId - 需求ID
 */
export function inviteSupplier(data) {
  return request({
    url: "/app/referralsSupplier/inviteSupplier",
    method: "post",
    data,
  });
}

/**
 * 删除产品需求
 * @param {string|number} demandId - 需求ID
 */
export function removeDemand(demandId) {
  return request({
    url: `/app/demand/remove/${demandId}`,
    method: "post",
  });
}

/**
 * 修改产品需求（验样阶段）
 */
export function editDemand(data) {
  return request({
    url: "/app/demand/edit",
    method: "post",
    data,
  });
}

/**
 * 采购方结束竞价
 */
export function finishBidding(demandId) {
  return request({
    url: `/app/bidding/finishBidding/${demandId}`,
    method: "get",
  });
}

/**
 * 查询产品分类列表
 */
export function getProductTypeList() {
  return request({
    url: "/app/productType/list",
    method: "get",
  });
}

/**
 * 我的产品分类
 */
export function getMyProductType() {
  return request({
    url: "/app/userProductType/myProductType",
    method: "get",
  });
}

/**
 * 删除申请验样
 */
export function removeApplyVerify(applyVerifyId) {
  return request({
    url: `/app/applyVerify/remove/${applyVerifyId}`,
    method: "get",
  });
}

/**
 * 删除竞价
 */
export function removeBidding(biddingId) {
  return request({
    url: `/app/bidding/remove/${biddingId}`,
    method: "get",
  });
}

// 我的关联订单
export function getMyRelationOrder(params) {
  return request({
    url: "/app/demandOrder/myRelationOrder",
    method: "get",
    params,
  });
}
